import React, { useState } from "react";
import "./GalleryPage.css";

const galleryImages = [
  {
    id: 1,
    category: "Education",
    image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800",
    title: "Education Program"
  },
  {
    id: 2,
    category: "Water",
    image: "https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=800",
    title: "Water & Sanitation"
  },
  {
    id: 3,
    category: "Women",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800",
    title: "Women Empowerment"
  },
  {
    id: 4,
    category: "Environment",
    image: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=800",
    title: "Environment"
  },
  {
    id: 5,
    category: "Livelihood",
    image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800",
    title: "Livelihood"
  },
  {
    id: 6,
    category: "Health",
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=800",
    title: "Health Camp"
  },
  {
    id: 7,
    category: "Education",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800",
    title: "School Activities"
  },
  {
    id: 8,
    category: "Water",
    image: "https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=800",
    title: "Community Water Project"
  },
  {
    id: 9,
    category: "Environment",
    image: "https://images.unsplash.com/photo-1473448912268-2022ce9509d8?w=800",
    title: "Tree Plantation"
  },
  {
    id: 10,
    category: "Women",
    image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800",
    title: "Skill Development"
  },
  {
    id: 11,
    category: "Livelihood",
    image: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800",
    title: "Village Development"
  },
  {
    id: 12,
    category: "Health",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800",
    title: "Medical Outreach"
  }
];

const categories = [
  "All",
  "Education",
  "Water",
  "Women",
  "Environment",
  "Livelihood",
  "Health"
];

const GalleryPage = () => {

  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredImages =
    selectedCategory === "All"
      ? galleryImages
      : galleryImages.filter(
          (item) => item.category === selectedCategory
        );

  return (
    <div className="gallery-page">

      {/* HERO */}

      <section className="gallery-hero">

        <div className="gallery-overlay">

          <h1>Our Gallery</h1>

          <p>
            Capturing moments of transformation, hope and sustainable
            development.
          </p>

        </div>

      </section>

      {/* FILTER */}

      <section className="gallery-filter-section">

        <div className="gallery-container">

          <h2>Explore Our Journey</h2>

          <div className="gallery-filters">

            {categories.map((category) => (

              <button
                key={category}
                className={
                  selectedCategory === category
                    ? "filter-btn active"
                    : "filter-btn"
                }
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>

            ))}

          </div>

        </div>

      </section>

      {/* GALLERY */}

      <section className="gallery-section">

        <div className="gallery-container">

          <div className="gallery-grid">

            {filteredImages.map((item) => (

              <div
                className="gallery-item"
                key={item.id}
                onClick={() => setSelectedImage(item)}
              >

                <img
                  src={item.image}
                  alt={item.title}
                />

                <div className="gallery-hover">

                  <h4>{item.title}</h4>

                  <span>{item.category}</span>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* LIGHTBOX */}

      {selectedImage && (

        <div
          className="lightbox"
          onClick={() => setSelectedImage(null)}
        >

          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>

            <img
              src={selectedImage.image}
              alt={selectedImage.title}
            />

            <h3>{selectedImage.title}</h3>

            <p>{selectedImage.category}</p>

          </div>

        </div>

      )}

    </div>
  );
};

export default GalleryPage;